import { render, staticRenderFns } from "./search_bar.vue?vue&type=template&id=cff78060&scoped=true"
import script from "./search_bar.vue?vue&type=script&lang=js"
export * from "./search_bar.vue?vue&type=script&lang=js"
import style0 from "./search_bar.vue?vue&type=style&index=0&id=cff78060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff78060",
  null
  
)

export default component.exports